export default "__VITE_ASSET__BgiFDqmT__"